module.exports = __webpack_public_path__ + "img/ic_fuchao.f32ee198.png";